import BaseAnimation from './BaseAnimation.js';

class NumberAnimation extends BaseAnimation {
	animate() {
		let $targets = this.$scope.is('[data-number-target]')
			? this.$scope
			: this.$scope.find('[data-number-target]');

		$targets.each((index, element) => this.countUp(element));
	}

	countUp(element) {
		let raw = element.getAttribute('data-number-target') ?? '';
		let useComma = raw.includes(',');
		let target = parseFloat(raw.replace(',', '.'));
		let decimals = (raw.replace(',', '.').split('.')[1] || '').length;
		let duration = parseInt(element.getAttribute('data-number-duration')) || 2000;

		if (isNaN(target)) return;

		let start = performance.now();

		let update = (now) => {
			let progress = Math.min((now - start) / duration, 1);
			let eased = 1 - Math.pow(1 - progress, 3);

			let value = eased * target;
			value = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();

			if (useComma) {
				value = value.replace('.', ',');
			}

			element.textContent = value;

			if (progress < 1) {
				requestAnimationFrame(update);
			}
		};

		requestAnimationFrame(update);
	}
}

export default NumberAnimation;
